import { MOBILE_BREAKPOINT, TABLET_BREAKPOINT } from '$lib/constants';
import { ScreenSize } from '$lib/enums';

export const screenSizeFromWidth = (width: number): ScreenSize => {
	if (width > TABLET_BREAKPOINT) return ScreenSize.DESKTOP;
	if (width > MOBILE_BREAKPOINT) return ScreenSize.TABLET;
	return ScreenSize.MOBILE;
};
